import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import { components } from 'react-select';
import { get } from 'helpers/api';
import { debounce, isEmpty } from 'lodash';
import { Modal } from 'react-bootstrap';

import BrokersList from './brokers_list';
import ErrorAlert from './error_alert';
import Button from 'shared/button';

const Option = (props) => {
  return (
    <components.Option {...props}>
      <div>
        <strong>{props.data.label}</strong>
      </div>
      {props.data.source && <small>Source: {props.data.source}</small>}
    </components.Option>
  );
};
Option.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string.isRequired,
    source: PropTypes.string.isRequired
  }).isRequired
};

export default function NewPropertyFromExisting({
  edgeCrmAccess,
  errorMessages,
  gotoPrevStep,
  hasErrors,
  maxBrokersLimit,
  saving,
  showBrokerSelect,
  onSave
}) {
  const [researchPropertyId, setResearchPropertyId] = useState();
  const [brokers, setBrokers] = useState([{}]);

  const searchResearchProperties = (inputValue, callback) => {
    const params = { allDatabases: true, 'q[name_or_address_cont]': inputValue };

    get('/research/properties', { params }).then((data) => {
      const foundProperties = data.properties.map(property => ({
        label: property.address,
        value: property.id,
        source: edgeCrmAccess ? null : property.databaseName,
      }));
      callback(foundProperties);
    });
  };

  const save = () => {
    const newListing = { researchPropertyId, brokerIds: brokers.map(broker => broker.value || {}) };
    if (edgeCrmAccess) {
      newListing.edgeResearchPropertyId = researchPropertyId;
    }
    onSave(newListing);
  };

  const saveButtonDisabled = saving
    || !researchPropertyId
    || (showBrokerSelect && brokers.some(item => isEmpty(item)));

  return (
    <div>
      <Modal.Body className="modal-padding">
        <h3 className="mb-5 mt-0 text-center" style={{ fontWeight: 'bold' }}>Create from an existing property</h3>
        <ErrorAlert errorMessages={errorMessages} hasErrors={hasErrors} />
        <div className="mb-4">
          <label>Select an existing property</label>
          <AsyncSelect
            classNamePrefix="react-select"
            components={{ Option }}
            loadOptions={debounce(searchResearchProperties, 300)}
            menuPortalTarget={document.body}
            placeholder={'Search by name'}
            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            onChange={({ value }) => {
              setResearchPropertyId(value);
            }}
          />
        </div>

        {researchPropertyId && showBrokerSelect && (
          <div className="mb-4">
            <BrokersList
              brokers={brokers}
              maxBrokersLimit={maxBrokersLimit}
              onSetBrokers={setBrokers}
            />
          </div>
        )}

        <div className="mt-5">
          {gotoPrevStep && (
            <Button.Accent className="mr-3" outlined type="button" onClick={gotoPrevStep}>Back</Button.Accent>
          )}
          <Button.Primary disabled={saveButtonDisabled} name="save" type="button" onClick={save}>
            {saving ? 'Saving ...' : 'Create new listing'}
          </Button.Primary>
        </div>
      </Modal.Body>
    </div>
  );
}

NewPropertyFromExisting.propTypes = {
  edgeCrmAccess: PropTypes.bool,
  errorMessages: PropTypes.object,
  gotoPrevStep: PropTypes.func,
  hasErrors: PropTypes.bool.isRequired,
  maxBrokersLimit: PropTypes.number.isRequired,
  saving: PropTypes.bool.isRequired,
  showBrokerSelect: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired
};
